import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import top from '@/components/top'
import bottom from '@/components/bottom'
import gsintro from '@/components/gsintro'
import cpintro from '@/components/cpintro'
import joinus from '@/components/joinus'
import contact from '@/components/contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    }, {
      path: '/top',
      name: 'top',
      component: top
    }, {
      path: '/bottom',
      name: 'bottom',
      component: bottom
    }, {
      path: '/gsintro',
      name: 'gsintro',
      component: gsintro
    }, {
      path: '/cpintro',
      name: 'cpintro',
      component: cpintro
    }, {
      path: '/joinus',
      name: 'joinus',
      component: joinus
    }, {
      path: '/contact',
      name: 'contact',
      component: contact
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js